var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my-date-row"},[_c('badge',{attrs:{"type":_vm.latencyBageType}},[_vm._v(_vm._s(_vm.latency))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }